import { Select } from "antd";
import { adminLocaleOptions, switchAdminLocale, useAdminLocale } from "../lib/locale";
import { formatMessage } from "@umijs/max";

type AdminLocaleSwitcherTone = "default" | "subtle";

type AdminLocaleSwitcherProps = {
  tone?: AdminLocaleSwitcherTone;
  className?: string;
};

export function AdminLocaleSwitcher({
  tone = "default",
  className,
}: AdminLocaleSwitcherProps) {
  const locale = useAdminLocale();
  const wrapperClassName = ["admin-locale-switcher", `admin-locale-switcher--${tone}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <Select
        value={locale}
        onChange={switchAdminLocale}
        options={adminLocaleOptions}
        variant="borderless"
        classNames={{ popup: { root: "admin-locale-dropdown" } }}
        popupMatchSelectWidth={false}
        aria-label={formatMessage({ id: "common.fields.language" })}
      />
    </div>
  );
}
